import request from "@/utils/request";

// 管辖部门树
export function jurisdictionDeptTree(params) {
    return request({
        url: '/system/user/jurisdictionDeptTree', method: 'get', params
    })
}
